import ExperienceRate from './ExperienceRate'

export default ExperienceRate
